const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');
const { Image } = require('nordic/image');
const NewsDetailBody = require('./NewsDetailBody');
const FeedbackThumbs = require('../../../FeedbackThumbs');
const { useNewsListContext } = require('../../../../../providers/newsListContextProvider');
const BackTo = require('../../../../common/BackTo');
const NotFound = require('../../../NotFound');
const { default: ShareLink } = require('./ShareLink');
const { isVoiced } = require('../common/utils');

function NewsDetail(props) {
  const { i18n, lang, platform } = useNewsListContext();
  const { news, deviceType } = props;

  const dateFormat = 'DD-MM-YYYY';
  const formatedNews = moment(news?.date_published).locale(lang).format(dateFormat);
  const postAuthor = news?.content_author ? `| ${news.content_author}` : '';

  const voicedParam = {
    sites: news?.sites,
    title: news?.title,
    summary: news?.summary,
    lang,
    siteId: platform?.siteId,
  };

  const title = isVoiced(voicedParam) ? news.title.voiced : news.title[lang];

  return (
    news ? (
      <div className={`news-detail-container-${deviceType}`}>
        <div className="news-detail-header">
          <BackTo path={`/developers/${lang}/news`}> {i18n.gettext('Volver')} </BackTo>

          <div className="news-detail-header__container">
            {news.image_path_url && (
              <Image
                src={news.image_path_url}
                alt="post cover image"
                className="news-detail-image"
              />
            )}

            <h1 className="news-detail-header__title">{i18n.gettext(title)}</h1>
            <div className="news-detail-header__content">
              <p className="news-detail-header__content__date-author">{formatedNews} {postAuthor}</p>
              <ShareLink title={i18n.gettext(title)} />
            </div>
            <div className="news-detail-container-mobile-body">
              <NewsDetailBody
                detail={isVoiced(voicedParam) ? news.detail.voiced : news.detail[lang]}
                lang={lang}
                platform={platform}
              />
            </div>
          </div>
        </div>

        <FeedbackThumbs
          lang={lang}
          siteId={platform.siteId}
        />
      </div>) : (
        <NotFound className="news-detail-container" i18n={i18n} />)

  );
}

NewsDetail.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }),
  platform: PropTypes.shape({
    siteId: PropTypes.string,
    domain: PropTypes.string,
  }).isRequired,
  lang: PropTypes.string,
  actualUrl: PropTypes.shape({
    host: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    fullPath: PropTypes.string.isRequired,
  }).isRequired,
};

NewsDetail.defaultProps = {
  i18n: { gettext: () => {} },
};

module.exports = NewsDetail;
